import { render, staticRenderFns } from "./AddOrdFreightDetail.vue?vue&type=template&id=20e30220&scoped=true"
import script from "./AddOrdFreightDetail.vue?vue&type=script&lang=js"
export * from "./AddOrdFreightDetail.vue?vue&type=script&lang=js"
import style0 from "./AddOrdFreightDetail.vue?vue&type=style&index=0&id=20e30220&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e30220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e30220')) {
      api.createRecord('20e30220', component.options)
    } else {
      api.reload('20e30220', component.options)
    }
    module.hot.accept("./AddOrdFreightDetail.vue?vue&type=template&id=20e30220&scoped=true", function () {
      api.rerender('20e30220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryOrder/AddOrdFreightDetail.vue"
export default component.exports